<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.reports.parts_prices') }}
      </h1>
      <div class="ml-auto">
        <download-excel
          file-name="parts-prices.xlsx"
          url="/records-reports/parts-prices.xlsx"
          :filters="filters"
          :params="params"
        />
        <v-btn
          outlined
          large
          @click="toggleFilters"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>

    <table-filters
      v-if="filtersShown"
      :filters="filters"
      :no-items-found="noItemsFound"
      @search="getItems(true)"
    />

    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
    >
      <template v-slot:item.startDate="{ item }">
        {{ item.startDate && $moment(item.startDate).format('L') }}
      </template>

      <template v-slot:item.endDate="{ item }">
        {{ item.endDate && $moment(item.endDate).format('L') }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { priceTypes } from '@/utils/enums';
import TableFilters from '@/components/common/TableFilters.vue';
import DownloadExcel from '@/components/common/DownloadExcel.vue';

export default {
  name: 'PartsPrices',

  components: {
    TableFilters,
    DownloadExcel,
  },

  data() {
    return {
      items: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      total: 0,
      noItemsFound: false,

      loading: false,
      headers: [{
        text: this.$t('common.supplierAsdb'),
        value: 'supplier.asdb',
      }, {
        text: this.$t('common.supplier_name'),
        value: 'supplier.name',
        sortable: false,
      }, {
        text: this.$t('common.plant'),
        value: 'plant',
      }, {
        text: this.$t('common.part_number'),
        value: 'part.number',
      }, {
        text: this.$t('common.part_name'),
        value: 'part.name',
        sortable: false,
      }, {
        text: this.$t('common.price'),
        value: 'price',
      }, {
        text: this.$t('common.currency'),
        value: 'currency',
      }, {
        text: this.$t('common.dateFrom'),
        value: 'startDate',
      },
      {
        text: this.$t('common.dateTo'),
        value: 'endDate',
      }],

      filtersShown: true,
      filters: [{
        label: this.$store.getters.business ? this.$t('common.seller') : this.$t('common.supplier'),
        key: 'supplier',
        value: '',
        requiredForSupplier: true,
      }, {
        label: this.$t('common.part'),
        key: 'part',
        cols: 3,
        value: '',
      }, {
        label: this.$t('views.reports.price_type'),
        key: 'priceType',
        type: 'select',
        cols: 3,
        value: 'current',
        options: priceTypes.map((type) => ({
          value: type,
          text: this.$t(`enums.price_types.${type}`),
        })),
      }],
    };
  },

  computed: {
    ...mapState({
      user: 'user',
      supplierData: 'supplier',
    }),
    ...mapGetters(['business', 'full', 'editor']),
    params: {
      get() {
        const params = {};

        const {
          sortBy, sortDesc, page, itemsPerPage,
        } = this.options;

        if (itemsPerPage !== -1) {
          params.pageSize = itemsPerPage;
          params.page = page;
        }

        this.filters.forEach((it) => {
          if (it.value) {
            params[it.key] = it.value;
          }
        });

        if (sortBy.length) {
          params.sort = sortBy.reduce((acc, field, i) => {
            const direction = sortDesc[i] ? '-' : '';
            return acc ? `${acc} ${direction}${field}` : `${direction}${field}`;
          }, '');
        }

        return params;
      },
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.loading) {
          this.getItems();
        }
      },
      deep: true,
    },
  },

  mounted() {
    // this.getItems();
  },

  methods: {
    async getItems(filtered) {
      this.loading = true;

      if (filtered) {
        this.options.page = 1;
      }

      try {
        const { data = {} } = await this.$http.get('/records-reports/parts-prices', { params: this.params });

        this.items = data.rows;
        this.total = data.total;
        this.noItemsFound = data.total === 0;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    toggleFilters() {
      if (this.items.length) {
        this.filtersShown = !this.filtersShown;
        return;
      }
      this.filtersShown = true;
    },
  },
};
</script>
